import { render, staticRenderFns } from "./MedicineCommissionQuestions.vue?vue&type=template&id=4c2a0178"
import script from "./MedicineCommissionQuestions.vue?vue&type=script&lang=js"
export * from "./MedicineCommissionQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports